module.exports = __webpack_public_path__ + "img/726.47ce627c.png";